export const VOTE_OUTCOME = {
  Success: 0,
  AlreadyVoted: 1,
  CaptchaNotRequired: 2,
  CaptchaFailed: 3,
  SolverError: 4,
  ProxyUnhealthy: 5,
  SiteError: 6,
  BrowserError: 7,
  Cancelled: 8,
  Unknown: 9,
  NoFreshExit: 10,
  ProviderUnavailable: 11,
} as const;

export const CAPTCHA_PATH = {
  NotAttempted: 0,
  NotRequired: 1,
  Solved: 2,
  Failed: 3,
} as const;

export interface VoteSiteDto {
  id: string;
  key: string;
  displayName: string;
  isEnabled: boolean;
}

export interface VoteStateDto {
  id: string;
  botRegistryId: string;
  minecraftUsername: string;
  voteSiteId: string;
  siteKey: string;
  siteDisplayName: string;
  lastVoteUtc: string | null;
  lastOutcome: number;
  lastFailureReason: string | null;
  consecutiveFailureCount: number;
  isStale: boolean;
  proxyHealthy: boolean;
  lastRedeemedUtc: string | null;
}

export interface VoteAttemptLogDto {
  id: string;
  botRegistryId: string;
  minecraftUsername: string;
  siteKey: string;
  startedUtc: string;
  finishedUtc: string;
  outcome: number;
  captchaPath: number;
  solverProvider: string | null;
  solverCostUsd: number | null;
  durationMs: number;
  errorClass: string | null;
  rawNotes: string | null;
}

export interface VoteResultDto {
  botRegistryId: string;
  siteKey: string;
  outcome: number;
  captchaPath: number;
  solverProvider: string | null;
  solverCostUsd: number | null;
  durationMs: number;
  errorClass: string | null;
  rawNotes: string | null;
}

export interface VotingSchedulerStatusDto {
  enabled: boolean;
  windowStartHourLocal: number;
  windowEndHourLocal: number;
  lastTickStartUtc: string | null;
  lastTickFinishUtc: string | null;
  lastTickInWindow: boolean;
  currentBotId: string | null;
  currentSiteKey: string | null;
}

export interface VotingTickReportDto {
  attempted: number;
}

export interface VoteAdminLogDto {
  id: string;
  minecraftUsernameRedacted: string;
  siteKey: string;
  startedUtc: string;
  finishedUtc: string;
  outcome: number;
  captchaPath: number;
  solverProvider: string | null;
  solverCostUsd: number | null;
  durationMs: number;
  errorClass: string | null;
  rawNotes: string | null;
}

export interface VoteAdminTodayDto {
  votingDayStartUtc: string;
  rows: VoteAdminTodayRowDto[];
}

export interface VoteAdminTodayRowDto {
  id: string;
  minecraftUsernameRedacted: string;
  siteKey: string;
  status: string;
  outcome: number | null;
  lastVoteUtc: string | null;
  redeemed: boolean;
  lastRedeemedUtc: string | null;
  proxyHealthy: boolean;
  isStale: boolean;
  isEnabled: boolean;
  isAdHoc: boolean;
  ownerUserId: string | null;
  ownerUsername: string | null;
}

export interface VoteAdHocDto {
  id: string;
  minecraftUsername: string;
  siteKey: string;
  proxyId: string | null;
  proxyName: string | null;
  lastVoteUtc: string | null;
  lastOutcome: number;
  isStale: boolean;
  isEnabled: boolean;
}

export function voteOutcomeKey(o: number): string {
  switch (o) {
    case VOTE_OUTCOME.Success: return 'VOTING_OUTCOME_SUCCESS';
    case VOTE_OUTCOME.AlreadyVoted: return 'VOTING_OUTCOME_ALREADY_VOTED';
    case VOTE_OUTCOME.CaptchaNotRequired: return 'VOTING_OUTCOME_CAPTCHA_NOT_REQUIRED';
    case VOTE_OUTCOME.CaptchaFailed: return 'VOTING_OUTCOME_CAPTCHA_FAILED';
    case VOTE_OUTCOME.SolverError: return 'VOTING_OUTCOME_SOLVER_ERROR';
    case VOTE_OUTCOME.ProxyUnhealthy: return 'VOTING_OUTCOME_PROXY_UNHEALTHY';
    case VOTE_OUTCOME.SiteError: return 'VOTING_OUTCOME_SITE_ERROR';
    case VOTE_OUTCOME.BrowserError: return 'VOTING_OUTCOME_BROWSER_ERROR';
    case VOTE_OUTCOME.Cancelled: return 'VOTING_OUTCOME_CANCELLED';
    case VOTE_OUTCOME.NoFreshExit: return 'VOTING_OUTCOME_NO_FRESH_EXIT';
    case VOTE_OUTCOME.ProviderUnavailable: return 'VOTING_OUTCOME_PROVIDER_UNAVAILABLE';
    default: return 'VOTING_OUTCOME_UNKNOWN';
  }
}

export function isPositiveOutcome(o: number): boolean {
  return o === VOTE_OUTCOME.Success || o === VOTE_OUTCOME.AlreadyVoted || o === VOTE_OUTCOME.CaptchaNotRequired;
}
